module.exports = __webpack_public_path__ + "img/plane_hard_ac.531f85a8.svg";